<template>
  <div class="donation">
    <PageBanner />
    <Breadcrumbs />

    <section class="content">
      <div class="container">
        <div class="speech">
          <h2 class="h4">總幹事的話</h2>
          <p>很高興在我們不斷努力下，「共享教育基金」獲得香港政府核准，在2019年正式成為一間慈善機構。我們致力面向各種類型的學習者，利用多媒體傳播各種知識。與時並進，服務社會，為全面推行香港免費教育而盡微薄力量。我們期望透過務實落地、全面創新並且推行可持續發展自物運作的工作手法，開展多項服務，並倡議、研究、教育、發展等各項教學領域。我們知道不是所有的種子都會長出幼苗，不是所有的夢想都能實現，不是所有的耕耘都有收穫，更不是所有人都能夠得到公平教育。因此我們督促自己不斷努力成長，並期望與全港學校、夥伴團體、前線工作者、義工、政府部門和基層社區攜手合作，共創香港美好未來。</p>
        </div>
        <p>Michelle Li</p>
        <div class="space"></div>
        <!-- timeline start -->
        <div class="timeline">
          <article
            class="post views-row"
            v-for="(event, index) in history"
            :key="index"
          >
            <div
              class="timeline-time h5"
              v-html="event.year"
            >
            </div>
            <div class="timeline-icon bg-black"></div>
            <div
              :class="index%2 ? 'timeline-content wow bounceInRight' : 'timeline-content wow bounceInLeft'"
              data-wow-duration="1s"
              data-wow-delay="0.2s"
            >
              <div
                class="entry-content"
                v-html="event.content"
              >
              </div>
            </div>
          </article>
        </div>
        <!-- timeline end -->
        <div class="space"></div>
        <!-- organization start -->
        <div class="person-list">
          <div class="row">
            <div
              class="person col-md-3 col-sm-6 mx-auto"
              v-for="(member, index) in org"
              :key="index"
            >
              <Person
                :index="index"
                :name="member.name"
                :cover="require('@/assets/img/'+ member.cover)"
                :title="member.title"
              />
            </div>
          </div>
        </div>
        <!-- organization end -->
        <div class="space"></div>
        <!-- team start -->
        <h2 class="h4">共享教育顧問團隊</h2>
        <div class="person-list">
          <div class="row">
            <div
              class="col-md-3 col-sm-6"
              v-for="(member, index) in team"
              :key="index"
            >
              <Person
                :index="index"
                :name="member.name"
                :cover="require('@/assets/img/'+ member.cover)"
                :title="member.title"
              />
            </div>
          </div>
        </div>
        <!-- team end -->
      </div>
    </section>
  </div>
</template>

<script>
  import PageBanner from "@/components/pageBanner.vue";
  import Breadcrumbs from "@/components/breadcrumbs.vue";
  import Person from "@/components/person.vue";
  import teamData from "@/assets/data/adviser.json";
  import orgData from "@/assets/data/organization.json";
  import historyData from "@/assets/data/history.json";
  export default {
    name: "Main",
    components: {
      PageBanner,
      Breadcrumbs,
      Person
    },
    data() {
      return {
        team: teamData,
        org: orgData,
        history: historyData.reverse()
      };
    }
  };
</script>